var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.selectFile}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"fileInput",attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),_c('div',[_vm._v(_vm._s(_vm.uploading?_vm.infoText:'上传文件'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }